// extracted by mini-css-extract-plugin
export default {"wrapper":"MB-z","addressLine":"NB-z","fullName":"OB-z"};